import { OverviewLayoutConfig } from './AddGiftsAndOverview.types';

export const OVERVIEW_LAYOUT_CONFIG: OverviewLayoutConfig = {
  variants: [
    {
      name: 'minFiveGifts',
      condition: {
        minGiftCount: 5,
      },
      rows: [
        'heroPromo',
        'giftCountAndGiftAdvisor',
        'departmentsCarousel',
        'curationsSection',
        'brandCarousel',
        'brandsMarquee',
        'thankYouNotesHighlight',
        'cardPromo',
        'etsyPromo',
        'framesPromo',
        'registryHighlights',
        'valueProps',
        //'recommendedCategories',
        'overviewFaq',
      ],
    },
  ],
  default: {
    name: 'default',
    rows: [
      'giftCountAndExploreRegistry',
      'mainPromo',
      'registryHighlights',
      'giftAdvisor',
      'departmentsCarousel',
      'curationsSection',
      'heroPromo',
      'brandCarousel',
      'brandsMarquee',
      'doYouHaveRegistry',
      'delayShippingPromo',
      'curationAndGroupGifting',
      'cashFundPromo',
      'thankYouNotesHighlight',
      'universalSearchAndCustomerSupport',
      'completionDiscountPromo',
      'valueProps',
      'etsyPromo',
      //'recommendedCategories',
      'overviewFaq',
    ],
  },
};
